import { IMessage } from 'src/app/models/message.interface';

export interface IMessageState {
    message: IMessage;
}

export const initialMessageState: IMessageState = {
    message: null
};
